module.exports = __webpack_public_path__ + "img/useravatar.d24420bd.png";